import { useState } from "react";
import { TextBtn } from "../../../../../shared";
import { Modal } from "antd";
import { ReactComponent as Edit } from '../../../../../assets/images/icon/edit.svg'
import { useGetNickNameDetailWeb } from "../../model";
import dayjs from "dayjs";
import NickNameCreateAndUpdateModal from "../nickNameCreateAndUpdateModal";

interface IProps {
    propsNickName: string | null;
    propsRefetch?: Function
}

const NickNameCreateAndUpdate = ({ propsNickName, propsRefetch }: IProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const [notAbleOpen, setNotAbleOpen] = useState<boolean>(false);
    const { data } = useGetNickNameDetailWeb();
    const onClickEditNickName = () => {
        if (!data) return;
        if (dayjs().isAfter(dayjs(data.lastUpdatedDate).startOf('d').add(30, 'd'))) {
            setOpen(true)
        } else {
            setNotAbleOpen(true)
        }
    }

    return <>
        <div>
            {propsNickName
                ? <div style={{ display: 'flex', gap: '4px' }}>
                    <div>{propsNickName}</div>
                    <Edit onClick={onClickEditNickName} width={16} height={16} fill='var(--secondarys400)' style={{ padding: '4px' }} />
                </div>
                : <TextBtn onClick={() => { setOpen(true) }} children={'닉네임 설정'} classNames={{ children: 'body/b3 secondary/s500' }} styles={{ container: { padding: 0 } }} />}
        </div>

        <NickNameCreateAndUpdateModal propsRefetch={propsRefetch} open={open} setOpen={setOpen} />

        <Modal centered open={notAbleOpen} onCancel={() => setNotAbleOpen(false)} style={{ padding: 0, margin: 0, maxWidth: '100%' }} styles={{ content: { padding: 0, borderRadius: '4px', marginInline: '23.5px' }, }} closeIcon={null} footer={null}>
            <div style={{ padding: '20px 16px', textAlign: 'center' }}>
                <div className="sub-title/st5 base/black" style={{ marginBottom: '8px' }}>
                    닉네임 변경 불가
                </div>
                <div className="body/b2 secondary/s800" style={{ marginBottom: '22px' }}>
                    닉네임은 30일에 1번 변경할 수 있습니다.<br />
                    다음 변경 가능일은 {dayjs(data?.lastUpdatedDate).startOf('d').add(30, 'd').format('M월 D일')} 입니다.
                </div>
                <div className="sub-title/st3 secondary/s600" style={{ paddingBlock: '12px', border: '1px solid var(--secondarys400, #AEAEAE)', borderRadius: '4px' }} onClick={() => setNotAbleOpen(false)}>
                    확인
                </div>
            </div>
        </Modal>

    </>
}

export default NickNameCreateAndUpdate;